import React, { useEffect, useState } from 'react';


interface CalculatorImageProps {
  value?: string;
}


const CalculatorImage: React.FC<CalculatorImageProps> = ({ value }) => {

  const [equalColor, setEqualColor] = useState('#455a64');

  useEffect(() => {
    setEqualColor('#4CAF50');
    const timer = setTimeout(() => {
      setEqualColor('#455a64');
    }, 1000);
    return () => clearTimeout(timer);
  }, [value]);
  
  
  return (
    <svg
      viewBox="0 0 500 500"
      style={{
        width: "70%",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M362 264.44a27.08 27.08 0 0 1-7 1.17l-2.87 5.95-10.65-2.47v-6.61a26.55 26.55 0 0 1-5.81-4.14l-6.24 2.18-5.78-9.28 4.69-4.65a26.59 26.59 0 0 1-1.17-7l-5.95-2.87 2.43-10.72h6.61a26.83 26.83 0 0 1 4.14-5.8l-2.18-6.2 9.28-5.79 4.65 4.69a27 27 0 0 1 7-1.17l2.88-5.95 10.65 2.47v6.61a26.5 26.5 0 0 1 5.8 4.14l6.24-2.18 5.79 9.28-4.69 4.65a26.94 26.94 0 0 1 1.17 7l5.95 2.87-2.46 10.66h-6.61a27.18 27.18 0 0 1-4.14 5.8l2.17 6.24-9.27 5.79-4.63-4.67zm-2.13-15.55a11.73 11.73 0 1 0-16.16-3.74 11.72 11.72 0 0 0 16.14 3.74z"
      />
      <path
        fill="#e0e0e0"
        d="M359.85 248.89a8.78 8.78 0 0 1-2.58 1.33 11.61 11.61 0 0 1-7.86-.1 11.83 11.83 0 0 1-4.6-3.05 12 12 0 0 1-2.93-5.62 11.3 11.3 0 0 1-.24-3.45 11.54 11.54 0 0 1 .81-3.52 12 12 0 0 1 12.09-7.55 12.07 12.07 0 0 1 6.52 2.55 12 12 0 0 1 3.76 5.1 11.84 11.84 0 0 1 .73 5.47 11.68 11.68 0 0 1-3.37 7.11 8.8 8.8 0 0 1-2.33 1.73A24.9 24.9 0 0 0 362 247a11.66 11.66 0 0 0 3.08-7 11.35 11.35 0 0 0-.77-5.22 11.53 11.53 0 0 0-3.62-4.82 11.09 11.09 0 0 0-2.85-1.62 10.63 10.63 0 0 0-3.34-.75 11.38 11.38 0 0 0-11.43 7.13 10.91 10.91 0 0 0-.78 3.33 10.76 10.76 0 0 0 .2 3.27 11.5 11.5 0 0 0 7.09 8.36 11.66 11.66 0 0 0 7.62.29c1.8-.55 2.61-1.15 2.65-1.08z"
      />
      <path
        fill="#e0e0e0"
        d="m362 264.44.3.27.9.87 3.52 3.47h-.13l9.24-5.85-.07.2c-.67-1.88-1.41-4-2.2-6.23v-.11l.08-.09a26.12 26.12 0 0 0 4.09-5.77l.06-.12h6.75l-.24.18c.77-3.35 1.59-6.92 2.44-10.66l.14.3-5.95-2.86-.15-.07v-.17a26.69 26.69 0 0 0-1.17-7l-.05-.17.12-.12c1.46-1.44 3.06-3 4.69-4.66v.38l-5.92-9.23.37.13-6.23 2.18-.19.06-.14-.13a26.72 26.72 0 0 0-5.73-4.09l-.18-.09v-6.81l.26.33-10.61-2.45.38-.18-2.88 6-.08.18h-.21a26.64 26.64 0 0 0-6.93 1.15l-.34-.09-.07-.07-.15-.15-.29-.3-.58-.59-1.17-1.17-2.32-2.34.42.05-9.28 5.79.14-.4q1.09 3.15 2.17 6.24l.07.19-.14.15a26 26 0 0 0-4.09 5.73l-.1.17h-6.8l.31-.25q-1.26 5.44-2.47 10.65l-.17-.35 5.95 2.88.16.08v.18a26.26 26.26 0 0 0 1.15 7l.05.17-.13.12-4.7 4.64v-.35l5.77 9.29-.3-.1 6.24-2.16.14-.05.11.1a26.83 26.83 0 0 0 5.74 4.12l.12.06v.14c0 2.4 0 4.56-.05 6.6l-.16-.19 10.64 2.51-.17.08 2.92-5.93v-.06h.06a28.15 28.15 0 0 0 5.32-.66l1.29-.31.43-.09-.42.15c-.28.09-.7.22-1.28.36a26.15 26.15 0 0 1-5.33.77l.09-.07-2.83 6-.06.11h-.11l-10.67-2.41h-.15v-6.77l.11.2a27 27 0 0 1-5.86-4.16l.24.05-6.23 2.19-.19.07-.11-.17-5.81-9.27-.12-.19.16-.16 4.68-4.65-.07.29a26.93 26.93 0 0 1-1.19-7.11l.17.26-6-2.86-.22-.11.05-.24 2.49-10.89.05-.25h6.87l-.29.17a27.2 27.2 0 0 1 4.19-5.88l-.07.34-2.18-6.24-.09-.25.23-.14 9.27-5.79.23-.15.19.19 2.32 2.34 1.16 1.18.59.59.29.3.15.14.07.08c-.68-.17-.19-.05-.34-.09a27.25 27.25 0 0 1 7.11-1.18l-.29.19 2.88-6 .11-.24.26.06 10.65 2.46.26.06v6.88l-.17-.29a27.17 27.17 0 0 1 5.87 4.19l-.32-.07 6.24-2.16.23-.09.14.22 5.78 9.28.12.2-.17.17c-1.63 1.62-3.24 3.2-4.7 4.64l.08-.29a27.42 27.42 0 0 1 1.17 7.11l-.16-.24 5.95 2.89.19.09-.05.2c-.87 3.74-1.71 7.3-2.49 10.65v.19h-6.8l.19-.12a26.84 26.84 0 0 1-4.19 5.83v-.2c.78 2.25 1.5 4.36 2.15 6.25l.05.13-.12.07-9.31 5.74h-.07l-.06-.06-3.41-3.52-.87-.92a2.19 2.19 0 0 1-.23-.22zm21.75-79.12a37.88 37.88 0 0 1-9.94 1.66l-4.07 8.41-15.06-3.48v-9.35a37.62 37.62 0 0 1-8.21-5.85l-8.82 3.08-8.18-13.12 6.63-6.57a37.87 37.87 0 0 1-1.65-9.95l-8.42-4.06 3.53-15.09h9.34a38 38 0 0 1 5.86-8.21l-3.08-8.79 13.12-8.18 6.57 6.63a37.8 37.8 0 0 1 9.94-1.65l4.07-8.42 15.06 3.49v9.34a38 38 0 0 1 8.2 5.85l8.82-3.07 8.19 13.11-6.65 6.62a37.41 37.41 0 0 1 1.66 9.94l8.41 4.07-3.48 15.06h-9.34a38 38 0 0 1-5.86 8.2l3.08 8.82-13.15 8.19-6.57-6.64zm-3-22a16.59 16.59 0 1 0-22.86-5.29 16.59 16.59 0 0 0 22.86 5.32z"
      />
      <path
        fill="#ebebeb"
        d="M419.23 235.14a20.41 20.41 0 0 1-5.29.88l-2.16 4.47-8-1.85v-5a20.35 20.35 0 0 1-4.37-3.11l-4.69 1.63-4.35-7 3.53-3.49a19.72 19.72 0 0 1-.88-5.29l-4.48-2.17 1.85-8h5a20.59 20.59 0 0 1 3.12-4.36l-1.64-4.69 7-4.36 3.5 3.53a20.41 20.41 0 0 1 5.29-.88l2.16-4.48 8 1.86v5a20.05 20.05 0 0 1 4.36 3.11l4.7-1.63 4.35 7-3.53 3.5a19.72 19.72 0 0 1 .88 5.29l4.48 2.16-1.85 8h-5a20.4 20.4 0 0 1-3.12 4.37l1.64 4.69-7 4.36-3.5-3.53zm-1.59-11.69a8.83 8.83 0 1 0-12.16-2.82 8.83 8.83 0 0 0 12.16 2.82z"
      />
      <path
        fill="#e0e0e0"
        d="M112.36 146.65c.11.1-4.58 4.91-10.47 10.73s-10.74 10.46-10.84 10.36 4.59-4.91 10.48-10.73 10.73-10.46 10.83-10.36z"
      />
      <path
        fill="#e0e0e0"
        d="M112.41 167.69c-.1.1-5-4.52-10.88-10.31S90.9 146.81 91 146.7s5 4.51 10.89 10.31 10.63 10.57 10.52 10.68zm21.16 112.05c0 .14-6-.38-13.36-1.15s-13.32-1.53-13.31-1.67 6 .37 13.36 1.15 13.33 1.52 13.31 1.67zm-1.06 10.04c0 .14-6-.37-13.36-1.15s-13.33-1.52-13.31-1.66 6 .37 13.36 1.14 13.33 1.53 13.31 1.67z"
      />
      <path
        fill="#ebebeb"
        d="M60.4 257.69s-7.92-.57-7.19 17.2 2.54 27.22 2.54 27.22-.23 3.94-3.28 3.17-8.79-4.61-11.63-1.74-1.89 7.53 2 12.9 12 17.44 12.74 18.53 1 3.09-1.16 2.9-16.76-5.14-18.69 1.93 11.39 20.2 12.82 21.7 1.51 2.4.93 3.29-5.33-1.24-9.54-2.48-9.31-1.93-10.08 2.24 5.09 16.37 27.06 29.2L67.49 399l10-6.38c20.57-15 25.19-27.69 24-31.77s-6.19-2.87-10.25-1.21-8.58 4.24-9.24 3.41-.68-1.75.59-3.36 13.21-16 10.58-22.88-16.66-.45-18.79 0-2-1.63-1.44-2.77 7.47-14 10.82-19.72 3.92-10.37.7-13-8.46 1.78-11.38 2.85-3.58-2.82-3.58-2.82.85-9.6-.2-27.34-9.06-16.32-9.06-16.32"
      />
      <path
        fill="#e0e0e0"
        d="M61 273.6a2.89 2.89 0 0 1 0 .37c0 .27 0 .63.08 1.09.07 1 .16 2.39.29 4.2.24 3.64.55 8.92.91 15.43.72 13 1.57 31.06 2.44 51s1.67 37.93 2.32 51c.33 6.5.6 11.78.79 15.44l.21 4.2v1.09a3.39 3.39 0 0 1 0 .37v-.37c0-.25 0-.62-.08-1.09-.07-1-.17-2.38-.29-4.19-.24-3.64-.55-8.92-.91-15.44-.73-13-1.57-31.05-2.44-51s-1.67-37.92-2.33-51c-.33-6.51-.6-11.78-.78-15.44l-.21-4.2v-1.46z"
      />
      <path
        fill="#e0e0e0"
        d="M48.66 309.22a3.59 3.59 0 0 1 .65.55c.41.37 1 .92 1.68 1.61 1.39 1.38 3.27 3.34 5.3 5.54l5.17 5.66 1.57 1.7a3.28 3.28 0 0 1 .55.66 4 4 0 0 1-.66-.54c-.4-.38-1-.93-1.67-1.63-1.38-1.39-3.25-3.37-5.25-5.57l-5.21-5.62-1.58-1.7a3.08 3.08 0 0 1-.55-.66zm15.97 15.37c-.08-.08 3.79-4.13 8.63-9s8.85-8.84 8.93-8.76-3.79 4.13-8.64 9-8.84 8.84-8.92 8.76zm-.04 30.63a3.56 3.56 0 0 1 .73-.47l2.07-1.16c1.75-1 4.15-2.34 6.75-3.94s4.91-3.12 6.57-4.23l2-1.31a3.53 3.53 0 0 1 .75-.45 3.8 3.8 0 0 1-.66.57c-.44.35-1.09.84-1.9 1.43-1.63 1.17-3.92 2.74-6.53 4.33s-5 2.93-6.82 3.85c-.9.45-1.62.81-2.13 1.05a4.6 4.6 0 0 1-.83.33zM47.08 344.5a3 3 0 0 1 .73.34c.46.24 1.11.61 1.92 1.07 1.6.91 3.81 2.2 6.24 3.64s4.61 2.77 6.18 3.75l1.85 1.17a3 3 0 0 1 .65.48 3.64 3.64 0 0 1-.73-.34c-.45-.25-1.11-.61-1.91-1.07-1.61-.91-3.82-2.2-6.25-3.64s-4.61-2.77-6.18-3.75L47.73 345a3.34 3.34 0 0 1-.65-.5zm-3.47 27.03a5.86 5.86 0 0 1 .92.45l2.47 1.36c2.07 1.16 4.92 2.79 8 4.61s5.95 3.48 8 4.71l2.4 1.47a5.6 5.6 0 0 1 .85.58 4.1 4.1 0 0 1-.93-.45l-2.46-1.35c-2.07-1.16-4.91-2.79-8-4.61s-5.95-3.49-8-4.71l-2.39-1.47a4.18 4.18 0 0 1-.86-.59zm22.2 12.72a4.51 4.51 0 0 1 .92-.62l2.56-1.56c2.17-1.33 5.16-3.16 8.4-5.28s6.14-4.1 8.23-5.55l2.47-1.71a4.36 4.36 0 0 1 .93-.59 5.75 5.75 0 0 1-.84.71c-.56.45-1.38 1.07-2.4 1.83-2 1.51-4.91 3.54-8.16 5.65s-6.27 3.92-8.48 5.18c-1.11.63-2 1.13-2.64 1.46a7 7 0 0 1-.99.48zm15.88 18.24H52.45l9.54 72.24h10.16l9.54-72.24z"
      />
      <path
        fill="#f5f5f5"
        d="M54 411.37s0 .1.15.25a1.85 1.85 0 0 0 .71.51 3.57 3.57 0 0 0 3.09-.38c1.18-.65 2.21-1.93 3.79-2.5a8.29 8.29 0 0 1 5.38.11 23.21 23.21 0 0 1 5 2.42 33.63 33.63 0 0 0 4.05 2.22 11.47 11.47 0 0 0 3 .87 6.15 6.15 0 0 0 .85.06h.29a15 15 0 0 1-4-1.21 41.85 41.85 0 0 1-4-2.25 22.57 22.57 0 0 0-5.09-2.51 8.59 8.59 0 0 0-5.68-.06 7.62 7.62 0 0 0-2.13 1.32 15.66 15.66 0 0 1-1.68 1.3 3.41 3.41 0 0 1-2.84.49 2.88 2.88 0 0 1-.89-.64zm1 13.3s.23-.3.68-.77a6.59 6.59 0 0 1 2.34-1.49 10.45 10.45 0 0 1 4.07-.61 43 43 0 0 1 5.08.7 17.48 17.48 0 0 0 5.21.21 14.15 14.15 0 0 0 4.1-1.17 13.22 13.22 0 0 0 2.52-1.46 3.53 3.53 0 0 0 .78-.71 27.66 27.66 0 0 1-3.38 1.86 14.88 14.88 0 0 1-4 1 17.4 17.4 0 0 1-5.08-.25 38.25 38.25 0 0 0-5.15-.66 10.43 10.43 0 0 0-4.21.74 6 6 0 0 0-2.34 1.67 4.6 4.6 0 0 0-.45.65c-.11.2-.17.28-.17.29zm23.38 7.12a2.55 2.55 0 0 0-.81-.41 8.25 8.25 0 0 0-2.42-.52 14.84 14.84 0 0 0-3.66.21c-1.37.22-2.83.59-4.36.92a18.61 18.61 0 0 1-4.36.49 9.56 9.56 0 0 1-3.46-.75 8 8 0 0 1-2.62-2 2.31 2.31 0 0 0 .5.76 6.09 6.09 0 0 0 2 1.5 9.23 9.23 0 0 0 3.58.88 17.65 17.65 0 0 0 4.47-.46c1.56-.33 3-.72 4.34-1a16.3 16.3 0 0 1 3.57-.31 13.81 13.81 0 0 1 3.23.69zm-20.76 10.02a4.74 4.74 0 0 1 2.84-.28 14 14 0 0 1 3 1.1 11.15 11.15 0 0 0 3.85 1.07 11.68 11.68 0 0 0 7-1.62 10.31 10.31 0 0 0 1.69-1.34c.35-.38.54-.6.51-.62a25.14 25.14 0 0 1-2.42 1.66 11.92 11.92 0 0 1-6.78 1.44c-2.77-.16-4.9-1.81-6.82-2a4.29 4.29 0 0 0-2.2.2c-.48.16-.69.38-.67.39zm1.63 13.87a5.64 5.64 0 0 0 2.44-.49c1.47-.49 3.28-1.61 5.41-2.46a9.07 9.07 0 0 1 3.11-.65 5.72 5.72 0 0 1 2.49.57 5.43 5.43 0 0 1 1.81 1.56 1.36 1.36 0 0 0-.28-.62 4 4 0 0 0-1.37-1.24 5.71 5.71 0 0 0-2.65-.71 8.71 8.71 0 0 0-3.28.65c-2.2.87-4 2-5.37 2.59s-2.32.72-2.31.8zm1.43 6.45a7.06 7.06 0 0 0 1.85.6 33.39 33.39 0 0 0 4.63.78 34.44 34.44 0 0 0 4.69.14 7.16 7.16 0 0 0 1.94-.23c0-.15-3 0-6.58-.38s-6.49-1.04-6.53-.91z"
      />
      <path
        fill="#263238"
        d="M471.27 473.56c0 .15-99.52.26-222.25.26s-222.26-.11-222.26-.26 99.49-.26 222.26-.26 222.25.12 222.25.26z"
      />
      <path
        fill="#eb996e"
        d="M176.85 132.4a6 6 0 0 1-1.74 1.51 14 14 0 0 1-2.22 1.22c-.88.33-1.86.67-2.88 1l-2.19.74.12-.07a35.18 35.18 0 0 1-4.05 3.75 35.4 35.4 0 0 1 3.66-4.1v-.05h.07l2.16-.76 2.87-1a17.41 17.41 0 0 0 2.2-1.08c1.26-.67 1.95-1.23 2-1.16z"
      />
      <path
        fill="#18365E"
        d="m334.74 340.12-161.42-16.63a9 9 0 0 1-8-9.86l27.93-271.38a12.78 12.78 0 0 1 14-11.39l153.92 15.85a12.78 12.78 0 0 1 11.39 14l-28 271.38a9 9 0 0 1-9.82 8.03z"
      />
      <path
        d="m334.74 340.12-161.42-16.63a9 9 0 0 1-8-9.86l27.93-271.38a12.78 12.78 0 0 1 14-11.39l153.92 15.85a12.78 12.78 0 0 1 11.39 14l-28 271.38a9 9 0 0 1-9.82 8.03z"
        opacity={0.4}
      />
      <path
        fill="#18365E"
        d="M318.45 338.44 157 321.82a9 9 0 0 1-8-9.87l28-271.38a12.76 12.76 0 0 1 14-11.39L344.88 45a12.76 12.76 0 0 1 11.39 14l-28 271.39a9 9 0 0 1-9.82 8.05z"
      />
      <rect
        width={60.8}
        height={26.86}
        x={176.76}
        y={261.64}
        fill="#18365E"
        rx={2.42}
        transform="rotate(5.88 207.21 275.17)"
      />
      <rect
        width={60.8}
        height={26.86}
        x={176.76}
        y={261.64}
        rx={2.42}
        transform="rotate(5.88 207.21 275.17)"
        opacity={0.4}
      />
      <path
        fill="#fafafa"
        d="m182.012 119.65 6.193-60.131 153.29 15.786-6.194 60.132z"
      />
      <path
        fill="#263238"
        d="M335.31 135.44s0-.37.09-1.07.17-1.75.3-3.11c.27-2.74.67-6.76 1.19-11.95 1-10.37 2.55-25.38 4.43-44l.16.2-153.29-15.73.29-.23c-2.17 21-4.27 41.35-6.21 60.13l-.22-.28 109.85 11.44 31.9 3.35 8.55.92 2.21.24.76.09s-.25 0-.74-.06l-2.18-.21-8.5-.84-31.9-3.21-110-11.22h-.25v-.24c1.93-18.79 4-39.11 6.18-60.14v-.26h.26l153.33 15.87h.18v.18c-2 18.67-3.55 33.72-4.64 44.11-.55 5.16-1 9.17-1.27 11.89-.15 1.35-.26 2.38-.34 3.08z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={186.7}
        y={145.78}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 199.873 158.898)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={186.7}
        y={145.78}
        rx={2.08}
        transform="rotate(5.88 199.873 158.898)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={182.68}
        y={145.37}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 195.851 158.52)"
      />
      <path
        fill="#fff"
        d="M198.18 153.11 197.07 164l-2.52-.26.91-8.84-2.17-.23.21-2z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={223.03}
        y={149.53}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 236.185 162.695)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={223.03}
        y={149.53}
        rx={2.08}
        transform="rotate(5.88 236.185 162.695)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={219.01}
        y={149.11}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 232.158 162.219)"
      />
      <path
        fill="#fff"
        d="m237.53 166.07-.21 2-8.2-.84.17-1.63 4.59-3.53c1.06-.81 1.29-1.35 1.34-1.88.09-.85-.45-1.41-1.6-1.53a2.67 2.67 0 0 0-2.36.86l-1.71-1.37a5.05 5.05 0 0 1 4.52-1.57c2.42.25 3.91 1.65 3.7 3.62-.1 1.06-.5 2-2.16 3.24l-2.74 2.1z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={260.7}
        y={153.41}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 273.864 166.52)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={260.7}
        y={153.41}
        rx={2.08}
        transform="rotate(5.88 273.864 166.52)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={256.68}
        y={152.99}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 269.843 166.14)"
      />
      <path
        fill="#fff"
        d="M275.24 168.66c-.19 1.83-1.77 3.36-4.86 3.05a7.56 7.56 0 0 1-4-1.59l1.17-1.83a5.3 5.3 0 0 0 3 1.3c1.26.13 2.09-.3 2.18-1.19s-.47-1.39-1.89-1.54l-1.15-.12.17-1.66 2.49-2.3-4.62-.47.21-2 7.6.78-.17 1.63-2.74 2.54a3.1 3.1 0 0 1 2.61 3.4z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={298.37}
        y={157.29}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 311.55 170.44)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={298.37}
        y={157.29}
        rx={2.08}
        transform="rotate(5.88 311.55 170.44)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={294.43}
        y={156.87}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 307.625 170.056)"
      />
      <path
        fill="#fff"
        d="m301.531 169.424.103-.995 11.638 1.199-.102.994zm8.299-4.764a1.9 1.9 0 1 1-1.7-2.08 1.9 1.9 0 0 1 1.7 2.08zm-1.05 10.15a1.9 1.9 0 1 1-1.69-2.08 1.9 1.9 0 0 1 1.69 2.08z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={182.77}
        y={183.95}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 195.879 197.075)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={182.77}
        y={183.95}
        rx={2.08}
        transform="rotate(5.88 195.879 197.075)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={178.75}
        y={183.54}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 191.857 196.696)"
      />
      <path
        fill="#fff"
        d="m196.54 200.18-1.77-.18-.24 2.28-2.45-.25.24-2.28-5.85-.61.17-1.69 5.83-6.36 2.64.28-5.42 6 2.92.3.21-2 2.37.24-.21 2 1.77.18z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={219.1}
        y={187.7}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 232.288 200.867)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={219.1}
        y={187.7}
        rx={2.08}
        transform="rotate(5.88 232.288 200.867)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={215.08}
        y={187.28}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 228.267 200.488)"
      />
      <path
        fill="#fff"
        d="M232.54 202.75c-.19 1.92-1.78 3.45-4.88 3.13a7.59 7.59 0 0 1-4-1.59l1.19-1.82a5.23 5.23 0 0 0 3 1.29c1.26.13 2.09-.31 2.18-1.2s-.41-1.47-2.38-1.67l-2.78-.29 1.19-6 6.62.68-.2 2-4.53-.47-.39 2.05.89.09c3.17.3 4.29 1.87 4.09 3.8z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={256.77}
        y={191.58}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 269.973 204.788)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={256.77}
        y={191.58}
        rx={2.08}
        transform="rotate(5.88 269.973 204.788)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={252.75}
        y={191.16}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 265.946 204.312)"
      />
      <path
        fill="#fff"
        d="M271 206.69c-.23 2.22-2.19 3.43-4.48 3.19-3-.31-4.66-2.38-4.3-5.88.39-3.76 2.87-5.62 6.14-5.28a5.9 5.9 0 0 1 2.95 1.06l-1.12 1.75a3.64 3.64 0 0 0-2-.76c-1.82-.18-3.09.77-3.38 2.84a3.71 3.71 0 0 1 2.78-.69 3.46 3.46 0 0 1 3.41 3.77zm-2.45-.13a1.64 1.64 0 0 0-1.67-1.82 1.71 1.71 0 0 0-2.05 1.44c-.1.93.53 1.68 1.74 1.81a1.63 1.63 0 0 0 1.95-1.43z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={294.43}
        y={195.46}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 307.653 208.612)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={294.43}
        y={195.46}
        rx={2.08}
        transform="rotate(5.88 307.653 208.612)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={290.41}
        y={195.04}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 303.631 208.233)"
      />
      <path fill="#fff" d="m298.602 211.36 9.187-7.245.62.786-9.188 7.245z" />
      <path fill="#fff" d="m299.437 203.949.776-.631 7.382 9.077-.776.63z" />
      <rect
        width={26.19}
        height={26.19}
        x={178.87}
        y={221.81}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 191.968 234.955)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={178.87}
        y={221.81}
        rx={2.08}
        transform="rotate(5.88 191.968 234.955)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={174.85}
        y={221.4}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 187.946 234.575)"
      />
      <path
        fill="#fff"
        d="m192.08 229.31-.17 1.63-5 8.82-2.73-.29 4.8-8.41-3.6-.37-.18 1.77-2.24-.23.4-3.81z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={215.2}
        y={225.56}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 228.377 238.746)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={215.2}
        y={225.56}
        rx={2.08}
        transform="rotate(5.88 228.377 238.746)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={211.18}
        y={225.14}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 224.35 238.27)"
      />
      <path
        fill="#fff"
        d="M229.5 241c-.21 2-2.17 3.15-4.93 2.86s-4.43-1.76-4.22-3.8a2.76 2.76 0 0 1 1.91-2.39 2.53 2.53 0 0 1-1-2.37c.2-1.91 2-2.92 4.49-2.67s4.08 1.63 3.89 3.54a2.54 2.54 0 0 1-1.51 2.1 2.76 2.76 0 0 1 1.37 2.73zm-2.54-.34c.1-1-.63-1.63-1.88-1.76s-2.08.38-2.18 1.34.61 1.65 1.86 1.78 2.11-.44 2.24-1.4zm-3.24-5c-.09.82.51 1.4 1.53 1.51s1.76-.34 1.85-1.16-.54-1.44-1.57-1.54-1.73.31-1.81 1.16z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={252.87}
        y={229.44}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 266.057 242.57)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={252.87}
        y={229.44}
        rx={2.08}
        transform="rotate(5.88 266.057 242.57)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={248.85}
        y={229.02}
        fill="#263238"
        rx={2.08}
        transform="matrix(.99 .1 -.1 .99 26.19 -25.57)"
      />
      <path
        fill="#fff"
        d="M267 242.28c-.39 3.76-2.85 5.62-6.14 5.28a5.82 5.82 0 0 1-2.93-1.05l1.12-1.75a3.55 3.55 0 0 0 2 .75c1.8.18 3.09-.77 3.38-2.85a3.75 3.75 0 0 1-2.8.7 3.47 3.47 0 0 1-3.39-3.77c.23-2.22 2.19-3.43 4.49-3.19 2.99.31 4.64 2.38 4.27 5.88zm-2.61-2.18c.09-.93-.54-1.68-1.73-1.81a1.64 1.64 0 1 0-.3 3.25 1.7 1.7 0 0 0 2.04-1.44z"
      />
      <rect
        width={26.19}
        height={26.19}
        x={290.53}
        y={233.32}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 303.741 246.492)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={290.53}
        y={233.32}
        rx={2.08}
        transform="rotate(5.88 303.741 246.492)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={286.51}
        y={232.9}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 299.72 246.112)"
      />
      <path fill="#fff" d="m293.75 245.907.102-.995 11.638 1.199-.102.995z" />
      <rect
        width={26.19}
        height={26.19}
        x={248.93}
        y={267.63}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 262.068 280.844)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={248.93}
        y={267.63}
        rx={2.08}
        transform="rotate(5.88 262.068 280.844)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={244.91}
        y={267.21}
        fill="#263238"
        rx={2.08}
        transform="rotate(5.88 258.041 280.368)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={286.6}
        y={271.51}
        fill="#18365E"
        rx={2.08}
        transform="rotate(5.88 299.748 284.668)"
      />
      <rect
        width={26.19}
        height={26.19}
        x={286.6}
        y={271.51}
        rx={2.08}
        transform="rotate(5.88 299.748 284.668)"
        opacity={0.4}
      />
      <rect
        width={26.19}
        height={26.19}
        x={282.58}
        y={271.09}
        fill={equalColor}
        rx={2.08}
        transform="rotate(5.88 295.726 284.289)"
      />
      <path
        fill="#fff"
        d="m289.967 282.681.102-.995 11.639 1.2-.103.994zm-.449 4.422.103-.995 11.638 1.199-.102.994z"
      />
      <rect
        width={63.23}
        height={26.86}
        x={169.45}
        y={261.01}
        fill="#263238"
        rx={2.5}
        transform="rotate(5.88 201.125 274.506)"
      />
      <path
        fill="#fff"
        d="M198.72 273.68c.37-3.59 2.57-5.41 5.24-5.14s4.44 2.51 4.07 6.1-2.55 5.41-5.23 5.13-4.45-2.51-4.08-6.09zm6.78.7c.26-2.47-.51-3.58-1.76-3.71s-2.22.8-2.47 3.27.51 3.58 1.75 3.71 2.23-.81 2.48-3.27zm51.322 11.669 1.371-11.62.993.117-1.37 11.62z"
      />
      <path fill="#fff" d="m252.147 280.212.102-.995 11.639 1.2-.103.994z" />
      <text
        x={228.369}
        y={79.756}
        fill="none"
        stroke="#000"
        transform="matrix(.97521 .113 -.1113 1.01252 0 0)"
        direction="rtl"
      >
        <tspan x={348.369} y={79.756}>
          {value}
        </tspan>
      </text>
      <path
        fill="#263238"
        d="M166.14 181.63v7.61c0 4.7.21 11.18.42 18.35s.24 13.67.06 18.36c-.08 2.35-.19 4.25-.3 5.56 0 .61-.09 1.11-.12 1.51s-.06.52-.06.52v-.52c0-.34.05-.91.08-1.51.09-1.31.17-3.21.23-5.56.14-4.7.08-11.19-.12-18.36s-.37-13.65-.36-18.35c0-2.35 0-4.25.07-5.57 0-.61 0-1.1.05-1.51s.05-.53.05-.53zm91.01 21.24a4.29 4.29 0 0 1 .14-.94c.12-.58.29-1.38.5-2.25s.4-1.67.55-2.23a3.89 3.89 0 0 1 .29-.91 4 4 0 0 1-.15.94c-.11.58-.29 1.37-.49 2.25s-.4 1.66-.55 2.23a4.38 4.38 0 0 1-.29.91zm3.65.56a30.6 30.6 0 0 1-.93-3.6 34.9 34.9 0 0 1-.73-3.65 33.14 33.14 0 0 1 .93 3.6 34.9 34.9 0 0 1 .73 3.65zm-32.07-3.98-.37-.34-1.05-1c-.9-.88-2.2-2.17-3.76-3.82a61.67 61.67 0 0 1-5.1-6.09 35.06 35.06 0 0 1-4.65-8.54 23.93 23.93 0 0 1-1.53-9.58 19.91 19.91 0 0 1 1.72-7.73 11.31 11.31 0 0 1 3.37-4.14 11 11 0 0 1 1.21-.8l.45-.25s-.62.34-1.61 1.11a11.5 11.5 0 0 0-3.29 4.14 20 20 0 0 0-1.66 7.68 23.77 23.77 0 0 0 1.54 9.5 35.58 35.58 0 0 0 4.6 8.5 64.47 64.47 0 0 0 5.06 6.1c1.54 1.66 2.82 3 3.71 3.87l1 1c.25.26.36.39.36.39z"
      />
      <path
        fill="#fafafa"
        d="M155.21 168.9a30.36 30.36 0 0 1-3 4.65 29.25 29.25 0 0 1-3.47 4.34 31.14 31.14 0 0 1 3-4.64 29.7 29.7 0 0 1 3.47-4.35z"
      />
      <path fill="#263238" d="M378.31 420.39h63.3v8.7h-63.3z" />
      <path
        fill="#263238"
        d="M441.71 429.19H378.2v-8.91h63.51zm-63.29-.19h63.07v-8.48h-63.07z"
      />
      <path
        fill="#263238"
        d="m384.18 426.19 9.11 44.94H427l8.8-42.05-51.62-2.89z"
      />
      <path fill="#455a64" d="m384.18 466.88 4.86 6.68h40.97l5.79-6.68h-51.62z" />
      <path
        fill="#263238"
        d="M407.58 427.5c-.13 0-.29-20.82-.36-46.5s0-46.51.1-46.51.28 20.82.35 46.51.03 46.5-.09 46.5zm14.1-52.11a2.86 2.86 0 0 1-.17.49l-.57 1.34c-.12.3-.26.62-.41 1l-.42 1.19c-.15.42-.32.87-.49 1.35s-.3 1-.47 1.55a63.23 63.23 0 0 0-1.77 7.75 96.07 96.07 0 0 0-1 9.69 131.52 131.52 0 0 0 .5 17.7c.21 2.26.41 4.09.56 5.35.07.59.12 1.07.16 1.45a3.27 3.27 0 0 1 0 .51 1.64 1.64 0 0 1-.12-.49c-.06-.38-.14-.86-.24-1.45-.21-1.25-.46-3.08-.7-5.34a116.14 116.14 0 0 1-.54-17.78 91.17 91.17 0 0 1 1-9.74 58.64 58.64 0 0 1 1.88-7.78c.17-.54.32-1.06.5-1.54l.52-1.35c.17-.42.32-.81.46-1.18s.32-.67.45-1l.65-1.31a2.15 2.15 0 0 1 .22-.41z"
      />
      <path
        fill="#263238"
        d="M420.06 358.55a6.11 6.11 0 0 1-.2.69c-.17.48-.39 1.12-.66 1.93-.15.43-.31.89-.48 1.4l-.51 1.68c-.37 1.21-.8 2.57-1.18 4.12-.21.76-.42 1.57-.64 2.4s-.39 1.73-.59 2.64c-.44 1.81-.76 3.78-1.17 5.83-.7 4.14-1.31 8.71-1.74 13.53s-.57 9.44-.63 13.64 0 8 .21 11.14c.06 1.59.16 3 .24 4.28s.15 2.34.23 3.23.12 1.53.16 2a3.48 3.48 0 0 1 0 .71 4 4 0 0 1-.11-.7l-.24-2c-.11-.88-.22-2-.31-3.22s-.23-2.69-.31-4.28c-.21-3.17-.3-7-.31-11.17s.2-8.83.6-13.66 1.06-9.43 1.78-13.57c.42-2.06.75-4 1.21-5.85.22-.91.42-1.79.62-2.63s.46-1.64.67-2.41c.4-1.54.85-2.91 1.25-4.11l.54-1.67c.19-.5.37-1 .52-1.39l.74-1.9a6.17 6.17 0 0 1 .31-.66zm-16.49 72.63v-.24c0-.19 0-.42-.06-.72-.05-.66-.11-1.58-.19-2.75-.15-2.43-.36-5.89-.63-10.15-.55-8.56-1.35-20.39-2.79-33.4-.73-6.5-1.59-12.68-2.47-18.28-.48-2.79-.9-5.45-1.39-7.93s-.92-4.78-1.37-6.88-.88-4-1.25-5.65-.72-3.08-1-4.25-.5-2-.65-2.68c-.07-.29-.12-.52-.16-.7s-.05-.24 0-.24a1.61 1.61 0 0 1 .08.23c0 .18.12.4.2.69.18.64.43 1.53.74 2.66s.71 2.57 1.1 4.23.88 3.54 1.32 5.65 1 4.39 1.42 6.87.94 5.14 1.43 7.94a375.7 375.7 0 0 1 2.51 18.29c1.44 13 2.19 24.87 2.66 33.44.23 4.28.39 7.75.49 10.15 0 1.17.08 2.1.1 2.76v.72a.64.64 0 0 1-.09.24z"
      />
      <path
        fill="#18365E"
        d="M407.06 344.5c-.27-2.95-3.25-5.18-6.22-5.21a9.79 9.79 0 0 0-7.53 4.09 23.72 23.72 0 0 0-3.63 8.06 54.48 54.48 0 0 0-2.23 21.43c.85 7.18 3.76 14.25 8.91 19.32.84.83 1.93 1.65 3.08 1.41a3.7 3.7 0 0 0 1.62-1 48 48 0 0 0 15.56-36.47c-.08-2.73-.44-5.57-1.95-7.84s-5-4.69-7.61-3.78m-22.12-23.64-4.17 7.56c-.1.17-.23.37-.43.39s-.38-.19-.5-.37q-5.52-8.47-11-16.94l2.54-1.44z"
      />
      <path
        d="m384.94 320.87-4.17 7.56c-.1.17-.23.37-.43.39s-.38-.19-.5-.37q-5.52-8.47-11-16.94l2.54-1.44z"
        opacity={0.2}
      />
      <path
        fill="#18365E"
        d="m407.32 334.49-37.63-22.21a1.73 1.73 0 0 1-.92-.92c-.15-.56.27-1.09.67-1.51a25.93 25.93 0 0 1 20.11-7.9 23 23 0 0 1 18.18 11.31c3.63 6.49 3.75 15.07-.41 21.23"
      />
      <path
        fill="#263238"
        d="M375.11 305.2a1.78 1.78 0 0 1 .49-.07c.33 0 .81-.07 1.42-.06a28.66 28.66 0 0 1 5.23.41 30.55 30.55 0 0 1 24.35 22 29.06 29.06 0 0 1 .94 5.15 10.66 10.66 0 0 1 0 1.1 1.73 1.73 0 0 1-.29.82 6.29 6.29 0 0 0 .06-1.9 32.6 32.6 0 0 0-1.06-5.08A31.29 31.29 0 0 0 377 305.24c-1.21-.03-1.89 0-1.89-.04z"
      />
      <path
        fill="#263238"
        d="M402.22 319.16a9.13 9.13 0 0 1-1.9.87c-1.2.47-2.87 1.07-4.75 1.67s-3.59 1.07-4.84 1.37a9.91 9.91 0 0 1-2.05.4 9.15 9.15 0 0 1 2-.7l4.8-1.5 4.77-1.54a10.2 10.2 0 0 1 1.97-.57zm-5.92-15.92a15.83 15.83 0 0 1 .44 4.2 16.16 16.16 0 0 1-.23 4.22 25.93 25.93 0 0 1-.22-4.21 26.61 26.61 0 0 1 .01-4.21zm-26.94 8.62a18.12 18.12 0 0 1 2.73-1c1.71-.53 4.09-1.19 6.75-1.83s5.07-1.13 6.84-1.44a16.83 16.83 0 0 1 2.87-.39 21.46 21.46 0 0 1-2.81.7c-1.74.39-4.15.93-6.8 1.56s-5 1.26-6.76 1.71a21.34 21.34 0 0 1-2.82.69z"
      />
      <path
        fill="#18365E"
        d="M391.44 338.1c-3.23-2.46-6.66-2.94-10.71-2.78a32.72 32.72 0 0 0-11.73 3c-6.35 2.78-12.31 6.87-16.1 12.67s-5.12 13.48-2.28 19.79a2.83 2.83 0 0 0 1.29 1.56 3 3 0 0 0 2.12-.16c7.22-2.35 14.49-4.73 21.12-8.42s12.68-8.81 16.24-15.51a13.46 13.46 0 0 0 1.71-5.15 6.37 6.37 0 0 0-1.66-5"
      />
      <path
        fill="#263238"
        d="M391.51 337.34a5 5 0 0 1-.52.21l-1.51.52-1.1.36-1.28.5c-.91.37-2 .74-3.09 1.28l-1.77.81c-.61.28-1.22.63-1.87 1-1.31.64-2.63 1.46-4 2.3a63.38 63.38 0 0 0-15.92 14c-1 1.3-2 2.5-2.8 3.72-.41.6-.83 1.16-1.19 1.74s-.7 1.12-1 1.65c-.68 1-1.19 2-1.67 2.9-.23.43-.46.83-.66 1.21l-.5 1c-.29.58-.52 1.06-.7 1.43a4.15 4.15 0 0 1-.28.49 2.73 2.73 0 0 1 .19-.53q.25-.57.63-1.47c.15-.32.3-.68.47-1.06s.4-.79.63-1.23c.46-.87.95-1.89 1.61-2.94l1-1.68c.35-.58.77-1.15 1.18-1.76.79-1.24 1.77-2.46 2.77-3.77a68.83 68.83 0 0 1 7.4-7.75 67.08 67.08 0 0 1 8.63-6.35c1.42-.83 2.76-1.64 4.09-2.27.65-.33 1.27-.67 1.89-.95l1.79-.78c1.14-.53 2.21-.88 3.13-1.22.47-.17.9-.34 1.3-.47l1.11-.33 1.54-.44a2.46 2.46 0 0 1 .5-.12zM366.22 351a76.06 76.06 0 0 1-7.87 2.53 73.84 73.84 0 0 1-8 2.11 75.53 75.53 0 0 1 7.87-2.54 76.48 76.48 0 0 1 8-2.1z"
      />
      <path
        fill="#263238"
        d="M365.9 368.4a12.66 12.66 0 0 1-.17-2.45c-.05-1.52-.05-3.61 0-5.93s.19-4.41.32-5.92a12.21 12.21 0 0 1 .31-2.44 15.07 15.07 0 0 1 0 2.46c-.06 1.66-.12 3.68-.19 5.91s-.1 4.26-.15 5.92a14.94 14.94 0 0 1-.12 2.45zm14.88-7.58c-.12 0-.52-4.25-.88-9.51s-.56-9.54-.44-9.55.52 4.25.89 9.52.56 9.53.43 9.54z"
      />
      <path
        fill="#263238"
        d="M362.26 341.35a14 14 0 0 1 2.52-.08c1.56 0 3.7.06 6.07.14s4.52.17 6.08.26a12.55 12.55 0 0 1 2.51.25 14.72 14.72 0 0 1-2.52.07c-1.56 0-3.71-.05-6.08-.13s-4.52-.18-6.07-.27a13.91 13.91 0 0 1-2.51-.24zM398 393.18a2 2 0 0 1-.05-.5c0-.38 0-.86-.07-1.45-.06-1.26-.07-3.08 0-5.33s.19-4.93.46-7.89.72-6.21 1.33-9.6 1.37-6.58 2.14-9.46 1.59-5.43 2.35-7.56 1.4-3.83 1.9-5l.57-1.34a2 2 0 0 1 .23-.46 2.54 2.54 0 0 1-.15.49l-.49 1.37c-.45 1.17-1.05 2.89-1.76 5s-1.48 4.7-2.25 7.57-1.48 6.06-2.1 9.43-1 6.61-1.35 9.56-.48 5.62-.56 7.86-.2 4.13-.2 5.36v1.45a2.42 2.42 0 0 1 0 .5z"
      />
      <path
        fill="#263238"
        d="M400 368.54a9.14 9.14 0 0 1-1.5 1.65c-1 1-2.35 2.27-3.93 3.66s-3 2.58-4.14 3.42a9.86 9.86 0 0 1-1.83 1.27 11.38 11.38 0 0 1 1.63-1.52l4-3.51 4-3.55a12.81 12.81 0 0 1 1.77-1.42zm11.88 9.6a16.16 16.16 0 0 1-1.6-2.22l-3.72-5.42c-1.44-2.05-2.75-3.89-3.8-5.38a18.29 18.29 0 0 1-1.52-2.27 16.75 16.75 0 0 1 1.78 2.08c1 1.33 2.44 3.19 3.91 5.31s2.73 4.07 3.61 5.51a16.23 16.23 0 0 1 1.34 2.39zM405.64 348c.06.11-3.89 2.77-8.84 6s-9 5.68-9.08 5.57 3.89-2.77 8.83-6 9.02-5.71 9.09-5.57zm11.15 12a148.94 148.94 0 0 1-11.65-11.38 76.54 76.54 0 0 1 6 5.53 72.24 72.24 0 0 1 5.65 5.85z"
      />
      <path
        fill="#18365E"
        d="m419.6 359.76 3.39-.28a16.73 16.73 0 0 0 6.86-2.1 26.53 26.53 0 0 1 3.2-1.6c4.2-1.69 8.89-1.39 13.4-1.62a55.47 55.47 0 0 0 21.33-5.45 2.1 2.1 0 0 0 .93-.84c.69-1.27-.6-2.4-1.72-3.09-5.72-3.53-11.54-7.1-18-8.85s-13.86-1.45-19.4 2.36c-6.5 4.47-8.86 13.66-10 21.47"
      />
      <path
        fill="#263238"
        d="M468.78 347.45a3.16 3.16 0 0 1-.57-.27l-1.61-.84c-1.4-.73-3.41-1.82-6-3a55.81 55.81 0 0 0-9.2-3.54 30.5 30.5 0 0 0-11.93-1 20.42 20.42 0 0 0-10.88 4.67 24.31 24.31 0 0 0-5.66 8 66.49 66.49 0 0 0-2.46 6.2c-.26.71-.46 1.28-.61 1.71a2.92 2.92 0 0 1-.24.59 4.57 4.57 0 0 1 .15-.62c.14-.44.31-1 .53-1.74a54.49 54.49 0 0 1 2.34-6.27 24 24 0 0 1 5.68-8.13 20.61 20.61 0 0 1 11.09-4.81 30.33 30.33 0 0 1 12.1 1 52.77 52.77 0 0 1 9.23 3.66c2.53 1.26 4.52 2.38 5.89 3.17l1.57.91a3.52 3.52 0 0 1 .58.31z"
      />
      <path
        fill="#263238"
        d="M460.63 351.83c-.07.11-4.52-2.77-9.92-6.41s-9.74-6.69-9.67-6.8 4.51 2.77 9.92 6.42 9.74 6.69 9.67 6.79zm-4.74-13.44a11 11 0 0 1-3.24.58 11.06 11.06 0 0 1-3.29 0 21.06 21.06 0 0 1 3.26-.33 20.47 20.47 0 0 1 3.27-.25zm-19.45-2.53a8.39 8.39 0 0 1-1.46 2.27 9.64 9.64 0 0 1-1.84 2.1 8.35 8.35 0 0 1 1.46-2.23 9.73 9.73 0 0 1 1.84-2.14zm3.98 18.59a12 12 0 0 1-2.14-1.16c-1.28-.78-3-1.92-4.87-3.26s-3.48-2.62-4.66-3.55a13.65 13.65 0 0 1-1.84-1.58 12.54 12.54 0 0 1 2 1.32l4.74 3.44c1.84 1.34 3.54 2.52 4.78 3.36a15.11 15.11 0 0 1 1.99 1.43z"
      />
      <path
        fill="#18365E"
        d="M424.6 374.19c-3.24-.85-7.1 2.3-7.77 5.58s.56 6.64 2 9.67a49.24 49.24 0 0 0 13.4 17.56 33.14 33.14 0 0 0 20.49 7.54c-1.37-6.36.36-13-.4-19.47a25.34 25.34 0 0 0-22.43-22.21c-2.07-.22-4.47-.55-5.29 1.36"
      />
      <path
        fill="#263238"
        d="M452.72 414.51a2.06 2.06 0 0 1-.46-.22 7.16 7.16 0 0 1-1.22-.81 12.61 12.61 0 0 1-3.19-4.28c-.52-1-1.1-2.09-1.66-3.29l-1.75-3.86a35.28 35.28 0 0 0-2.14-4.12 33.56 33.56 0 0 0-2.94-4c-2.22-2.61-4.6-4.86-6.67-7a45.76 45.76 0 0 1-5.07-6.09 22.48 22.48 0 0 1-2.49-4.74c-.2-.6-.35-1.06-.43-1.39a1.81 1.81 0 0 1-.1-.5s.22.66.7 1.83a24.43 24.43 0 0 0 2.58 4.62 48.22 48.22 0 0 0 5.11 6c2.07 2.13 4.47 4.38 6.71 7a32.76 32.76 0 0 1 3 4.07 37.63 37.63 0 0 1 2.14 4.18l1.71 3.87c.54 1.2 1.1 2.3 1.6 3.31a12.94 12.94 0 0 0 3 4.29c.95.78 1.59 1.09 1.57 1.13z"
      />
      <path
        fill="#263238"
        d="M436 409.22a11 11 0 0 1 .3-2.18c.26-1.33.67-3.16 1.23-5.16s1.17-3.77 1.65-5a10.19 10.19 0 0 1 .88-2 11.73 11.73 0 0 1-.58 2.12c-.4 1.29-.95 3.08-1.51 5.06s-1 3.8-1.36 5.11a10.62 10.62 0 0 1-.61 2.05zm16.1-15.61a13.54 13.54 0 0 1-2.28-.53c-1.39-.36-3.32-.86-5.47-1.34s-4.1-.86-5.52-1.13a12.55 12.55 0 0 1-2.28-.51 12.65 12.65 0 0 1 2.33.19c1.44.19 3.42.52 5.57 1s4.08 1 5.46 1.48a10.25 10.25 0 0 1 2.19.84zm-28.16 4.53a13.6 13.6 0 0 1 .35-2.52 91.144 91.144 0 0 1 3.1-11.89 14.17 14.17 0 0 1 .93-2.38 15.17 15.17 0 0 1-.62 2.47c-.43 1.51-1 3.59-1.63 5.91s-1.1 4.42-1.47 5.95a14 14 0 0 1-.66 2.46zM444.67 380c0 .12-4.06-.2-9-.73s-9-1.06-9-1.18 4.06.2 9 .73 9.01 1.06 9 1.18z"
      />
      <path
        fill="#455a64"
        d="M441.71 429.05c0 .12-14.22.22-31.75.22s-31.76-.1-31.76-.22 14.22-.23 31.76-.23 31.75.1 31.75.23zm-9.89 18.29c0 .13-9.58.23-21.4.23s-21.39-.1-21.39-.23 9.58-.22 21.39-.22 21.4.1 21.4.22zm-.38 2.66c0 .12-9.41.22-21 .22s-21-.1-21-.22 9.41-.23 21-.23 21 .06 21 .23zm.75-4.81c0 .12-9.91.22-22.13.22s-22.13-.1-22.13-.22 9.91-.23 22.13-.23 22.13.1 22.13.23z"
      />
      <g fill="#263238">
        <path d="M428 59.87c0 .15-6.71.23-15 .19s-15-.2-15-.34 6.71-.23 15-.19 15 .2 15 .34z" />
        <path d="M413.11 74.78c-.14 0-.32-6.7-.41-15s0-15 .11-15 .33 6.7.41 15 .04 15-.11 15zm30.65 208.9a100.22 100.22 0 0 1-9.2-4.4 98.58 98.58 0 0 1-9-4.88c.06-.12 4.18 1.85 9.2 4.41s9.07 4.75 9 4.87z" />
        <path d="M430.18 288.2a97.32 97.32 0 0 1 4.27-9.27 98.77 98.77 0 0 1 4.73-9 100 100 0 0 1-4.27 9.27 100.43 100.43 0 0 1-4.73 9z" />
      </g>
      <path
        fill="#263238"
        d="M140.71 109.32s.11.27.3.79.47 1.31.83 2.31c.72 2 1.78 5 3.13 8.88l.07.18h-.2L132 119.7h.13a33.45 33.45 0 0 1-15.41 6.73 32.69 32.69 0 0 1-4.79.41c-.82 0-1.65-.07-2.49-.09l-1.25-.06c-.42 0-.84-.12-1.26-.18a31.7 31.7 0 0 1-10.11-3 34.24 34.24 0 0 1-9.17-6.49A33.65 33.65 0 0 1 93 65.05a32.76 32.76 0 0 1 9.75-4.33l1.27-.33.63-.16.64-.1 2.56-.38c.85-.08 1.7-.1 2.55-.15a17.67 17.67 0 0 1 2.52 0c.83.07 1.67 0 2.48.18l2.43.38c.8.13 1.58.38 2.36.57l1.16.3c.38.12.75.27 1.12.4A33.41 33.41 0 0 1 141.38 78a33.61 33.61 0 0 1 3.52 13 32.57 32.57 0 0 1-3.12 16.27c-.33.67-.59 1.17-.77 1.49s-.3.5-.3.5.07-.17.24-.51.43-.85.73-1.52a33.63 33.63 0 0 0 2.1-6.09 31.85 31.85 0 0 0 .82-10.12 33.13 33.13 0 0 0-22.25-29.19c-.37-.13-.73-.27-1.11-.39l-1.14-.3c-.77-.18-1.54-.43-2.33-.55l-2.4-.37c-.8-.14-1.62-.11-2.45-.17a15.79 15.79 0 0 0-2.48 0c-.83 0-1.67.07-2.51.14l-2.52.39-.63.1-.63.16-1.25.32a32.12 32.12 0 0 0-9.59 4.28A33.1 33.1 0 0 0 97 123a31.25 31.25 0 0 0 10 3c.41.06.82.14 1.24.18l1.24.06c.83 0 1.64.12 2.45.1a31.77 31.77 0 0 0 4.73-.39 33.06 33.06 0 0 0 15.27-6.58h.07l12.86 1.84-.13.15c-1.31-3.87-2.32-6.88-3-9l-.77-2.31c-.18-.46-.25-.73-.25-.73z"
      />
      <path
        fill="#18365e"
        d="M110.11 100.38a1.35 1.35 0 0 1-.754-1.213l.038-6.66a1.34 1.34 0 0 1 1.707-1.27 4.21 4.21 0 0 0 3.263-.482 3.8 3.8 0 0 0 1.793-2.37 3.89 3.89 0 0 0-.663-2.914 4.3 4.3 0 0 0-2.74-1.835 5 5 0 0 0-5.259 3.36 1.34 1.34 0 0 1-2.545-.825 7.7 7.7 0 0 1 8.24-5.173 6.93 6.93 0 0 1 4.513 2.966 6.54 6.54 0 0 1 1.071 5.006 6.46 6.46 0 0 1-3.023 4.093 7 7 0 0 1-3.686.979l-.029 5.14a1.34 1.34 0 0 1-1.338 1.332 1.37 1.37 0 0 1-.589-.133zm-.733 2.396a1.1 1.1 0 1 1 1.12 1.07 1.11 1.11 0 0 1-1.12-1.07z"
      />
    </svg>
  )
}

export default CalculatorImage
